export * from './max-length.validator'
export * from './max.validator'
export * from './min-length.validator'
export * from './min.validator'
export * from './pattern.validator'
export * from './remote.validator'
export * from './required.validator'
export * from './min-array-length.validator'
export * from './max-form-array-length.validator'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/validators/index.ts